import { gql } from '@apollo/client';

export const opportunityAttributeLvlElasticity = gql`
    query getAttributeLvlElasticity(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $dimension: SamyaString!
        $limit: Int!
        $offset: Int!
    ) {
        getAttributeLvlElasticity(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filters: $filters
            dimension: $dimension
            limit: $limit
            offset: $offset
        ) {
            attributeData {
                attributeName
                ownElasticity
                internalCompetitorElasticity
                externalCompetitorElasticity
            }
            count
        }
    }
`;

export const opportunityAttributeLvlElasticityExport = gql`
    query getAttributeLvlElasticityExport(
        $timePeriod: JSONString!
        $attributesList: [SamyaString]!
        $filters: JSONString!
        $dimensionsList: [SamyaString]!
    ) {
        getAttributeLvlElasticityExport(
            timePeriod: $timePeriod
            attributesList: $attributesList
            filters: $filters
            dimensionsList: $dimensionsList
        )
    }
`;
